export const FETCH_DESIGNS = 'FETCH_DESIGNS';
export const SET_DESIGN = 'SET_DESIGN';
export const GET_DESIGN_INFO = 'GET_DESIGN_INFO';
export const GET_DESIGN_AUTH = 'GET_DESIGN_AUTH';
export const SET_DESIGN_INFO = 'SET_DESIGN_INFO';
export const SET_DESIGN_AUTH = 'SET_DESIGN_AUTH';
export const ADD_DESIGN = 'ADD_DESIGN';
export const ADD_SUCCESS_DESIGN = 'ADD_SUCCESS';
export const FETCH_SEARCH_DESIGNS = 'FETCH_SEARCH_DESIGNS';
export const SET_SEARCH_DESIGN = 'SET_SEARCH';
export const UPDATE_DESIGN = 'UPDATE_DESIGN';
export const UPDATE_DESIGN_AUTH = 'UPDATE_DESIGN_AUTH';
export const REQUEST_ACCESS = 'REQUEST_ACCESS';
export const UPDATE_DESIGN_DELETE = 'UPDATE_DESIGN_DELETE';
export const ADD_SUCCESS_FAVORITE = 'ADD_SUCCESS_FAVORITE';
export const FETCH_DESIGN_COUNTERS = 'FETCH_DESIGN_COUNTERS';
export const FETCH_COUNTER_DESIGNS = 'FETCH_COUNTER_DESIGNS';
export const SET_COUNTER_DESIGNS = 'SET_COUNTER_DESIGNS';
export const SET_DESIGN_COUNTERS = 'SET_DESIGN_COUNTERS';
export const UPDATE_DESIGNS = 'UPDATE_DESIGNS';
export const UPDATE_DESIGNS_FIELDS = 'UPDATE_DESIGNS_FIELDS';
export const CREATE_TEMPLATE_FROM_DESIGN = 'CREATE_TEMPLATE_FROM_DESIGN';
export const DUPLICATE_DESIGN = 'DUPLICATE_DESIGN';
export const CREATE_FROM_TEMPLATE = 'CREATE_FROM_TEMPLATE';
export const SET_COUNTER_SHARED_FILES = 'SET_COUNTER_SHARED_FILES';